import { Observable } from 'rxjs';

export type ShortlistMergeChoice = 'merge' | 'replace';

/**
 * Asked when a user signs in holding a local shortlist while their account already has one.
 * The data layer cannot open UI, so the app provides the implementation. Emitting `undefined`
 * leaves both lists untouched so the question is asked again next time.
 */
export abstract class ShortlistMergePrompt {
  public abstract choose(localCodes: string[], apiCodes: string[]): Observable<ShortlistMergeChoice | undefined>;
}
